import axios from "@/services/axios";

export default {
  methods: {
    async fetchPermissions() {
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(
          `/auth/permissions`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        this.$globalState.userPermissions = response.data.permissions;
        this.$globalState.permissionsLoaded = true;
      } catch (error) {
        console.error("Erro ao buscar permissões:", error);
        this.$globalState.permissionsLoaded = true; // ou false, conforme sua lógica
      }
    },
    hasPermission(permission) {
      const permissionsLoaded = this.$globalState.permissionsLoaded;
      const userPermissions = this.$globalState.userPermissions;

      if (!permissionsLoaded) {
        return true;
      }
      if (!userPermissions) {
        return false;
      }
      if (userPermissions.includes("administrador")) {
        return true;
      }
      return userPermissions.includes(permission);
    },
  },
};
